import { environment } from "src/environments/environment";

export const webApiUrl: string = environment.webApiUrl;
export const serverPath: string = environment.serverPath;
